import {
  CLEAR_SALES_AGENTS,
  CLEAR_SALES_AGENTS_NOTIFICATION,
  FETCH_ADMIN_SALES_AGENTS_BEGIN,
  FETCH_ADMIN_SALES_AGENTS_FAILURE,
  FETCH_ADMIN_SALES_AGENTS_SUCCESS,
  FETCH_ADMIN_SALES_AGENTS_BY_ID_BEGIN,
  FETCH_ADMIN_SALES_AGENTS_BY_ID_SUCCESS,
  FETCH_ADMIN_SALES_AGENTS_BY_ID_FAILURE,
} from 'actions/admin/salesAgentsActions';


const initialState = {
  salesAgents: [],
  salesAgentsDetails: {},
  loading: false,
  formSuccess: false,
  uploading: false,
  error: null,
  notification: null,
  pagination: {},
  filter: {},
};

export default function adminSalesAgentsReducer(state = initialState, action) {
  switch (action.type) {
    /*list page cases*/
    case FETCH_ADMIN_SALES_AGENTS_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
        notification: null,
      };
    case FETCH_ADMIN_SALES_AGENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        salesAgents: action.payload.salesAgents,
        pagination: action.payload.pagination,
        filters: action.payload.filters,
      };

    case FETCH_ADMIN_SALES_AGENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        salesAgents: [],
      };

    /*helper cases*/
    case CLEAR_SALES_AGENTS:
      return {
        ...state,
        ...initialState,
      };

    case CLEAR_SALES_AGENTS_NOTIFICATION:
      return {
        ...state,
        error: null,
        notification: null,
      };



    /*Details cases*/
    case FETCH_ADMIN_SALES_AGENTS_BY_ID_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
        notification: null,
        salesAgentsDetails: {},
        salesAgents: [],
      };
    case FETCH_ADMIN_SALES_AGENTS_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        salesAgentsDetails: action.payload.salesAgentsDetails,
      };

    case FETCH_ADMIN_SALES_AGENTS_BY_ID_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        salesAgentsDetails: {},
      };


    default:
      // Always have a default case in case a reducer doesn't complete
      return state;
  }
};
